import script from "./monitor.vue?vue&type=script&setup=true&lang=js"
export * from "./monitor.vue?vue&type=script&setup=true&lang=js"

import "./monitor.vue?vue&type=style&index=0&id=3a6ab028&scoped=true&lang=scss"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a6ab028"]])

export default __exports__